import React from 'react'
import Img from "gatsby-image";

import HeroSmall from '../components/HeroSmall'
import LocationMicroNav from '../components/LocationMicroNav'
import LocationContent from '../components/LocationContent'
import LocationRelated from '../components/LocationRelated'

class AlbanyLocation extends React.Component {
  render() {
    return (
      <div>
        <HeroSmall location="Albany, NY" />
        <LocationMicroNav />

        <LocationContent 
          category="E-bikes" 
          title="Empire State of Mind"
          story="At the New York Bicycling Coalition Annual Summit we provided an update on national, state and New York City e-bike policies to a group of 100 advocates, government staff, and business leaders. PeopleForBikes has been building a broad coalition of supporters as we work to pass a three-class e-bike bill in New York state. This event helped explain how New York stakeholders can play a role."
        /> 
        <Img
          title="Albany"
          alt="NY Bicycling Coalition logo"
          sizes= { this.props.data.albanyImage.sizes }
        />            

        <LocationRelated 
          prevLocationName="Arizona"
          prevLocationPath="arizona"
          prevLocationImgPath= { this.props.data.albanyPrevImage }
          nextLocationName="Park City, UT"
          nextLocationPath="park-city"
          nextLocationImgPath= { this.props.data.albanyNextImage }
        /> 
      </div>
    )
  }
}

export default AlbanyLocation

// GraphQL query
export const AlbanyImageQuery = graphql`
  query albanyImageQuery {
    albanyImage: imageSharp(id: { regex: "/PFB_Albany_NYBC.jpg/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    albanyPrevImage: imageSharp(id: { regex: "/PFB_ARIZONA/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    albanyNextImage: imageSharp(id: { regex: "/PFB_PARKCITY/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/albany.js